import PageLink from '@components/PageLink';
import useAPI from '@hooks/useAPI';
import useErrorHandler from '@hooks/useErrorHandler';
import useSession from '@hooks/useSession';
import Episode from '@models/Episode';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

interface CommentInputProps {
  episode: Episode;
  onRefreshComments: () => Promise<void>;
}

function CommentInput(props: CommentInputProps) {
  const session = useSession();
  const router = useRouter();
  const errorHandler = useErrorHandler();
  const API = useAPI();

  const [replyInput, setReplyInput] = useState('');

  async function addComment(content: string, replyCommentId?: string) {
    try {
      await API.addComments(props.episode.id, content, replyCommentId);
      await props.onRefreshComments();
    } catch (err) {
      errorHandler.handle(err);
    }
  }

  return (
    <div className="comment-input-component">
      <div className="my-comment-wrap">
        {session.isLoggedIn ? (
          <React.Fragment>
            <div className="my-comment-avatar">
              <img
                src={session.user?.avatar}
                loading="lazy"
                alt=""
                className="avatar-image"
              />
            </div>
            <div className="form-block w-form my-comment-form-wrapper">
              <form className="my-comment-form">
                <input
                  value={replyInput}
                  onChange={(e) => setReplyInput(e.target.value)}
                  placeholder="請寫下留言的內容"
                  className="my-comment-box w-input"
                />
                <a
                  className="button comment-button w-button"
                  onClick={() => {
                    session.isLoggedIn
                      ? addComment(replyInput)
                      : router.push('/login');
                  }}
                >
                  留言
                </a>
              </form>
            </div>
          </React.Fragment>
        ) : (
          <div
            className="my-comment-box w-input"
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: 0,
            }}
          >
            <img src={'/icons/login.svg'} alt="" />
            <p
              style={{
                color: 'white',
                margin: '0 12px',
              }}
            >
              你需要先註冊/登入才可以使用留言功能哦！
            </p>
            <PageLink
              to={'/login?url=' + (process.browser && window.location.href)}
            >
              <a
                style={{
                  color: '#15C7FF',
                  fontWeight: 'bolder',
                }}
              >
                馬上註冊/登入
              </a>
            </PageLink>
          </div>
        )}
      </div>
    </div>
  );
}

export default CommentInput;
